// E10: the neutral age screen before "Set it up" (mockups g01, g02; Play Families, mixed audience).
// Only a grown-up sets the app up; a younger person is sent to join a family instead. The year is
// checked on the phone and forgotten: nothing is stored or sent, and the screen never says where
// the line is, so it doesn't invite a made-up answer.

export const GROWN_UP_AGE = 18

/** A year that could be someone's year of birth, as of `now`. */
export function plausibleYear(year: number, now: Date): boolean {
  const y = now.getFullYear()
  return Number.isInteger(year) && year > y - 120 && year <= y
}

/** Old enough to set up, by year alone (someone who turns 18 this year counts). */
export function setsUp(year: number, now: Date): boolean {
  return plausibleYear(year, now) && now.getFullYear() - year >= GROWN_UP_AGE
}
